module.exports = __webpack_public_path__ + "static/media/extended_warranty_bottom.3c44bdec.png";